<template>
	<Loader :state="promise" text="Laster...">
		<div class="contact-page">
			<div class="contact-form__container">
				<FormLayout
					:action="submit"
					max-width="885px"
					:isValid="validator.passes"
					paddingLR="0rem"
					paddingTB="0rem"
					class="contact-page__form"
				>
					<template #default>
						<div class="contact-form__container-left">
							<TextField class="contact-form__container-left-title">
								<div v-html="title"></div>
							</TextField>

							<RadioButton v-model="category" class="mb-1" />

							<InputComponent
								v-if="isFieldVisible('name')"
								v-model="data.name"
								:label="labels.name"
								required
								floating-label
								:is-valid="!submitted || validator.fields.name.valid"
								validation-message="Du må fylle ut navn."
							/>
							<InputComponent
								v-if="isFieldVisible('company')"
								v-model="data.company"
								:label="labels.company"
								floating-label
								:is-valid="!submitted || validator.fields.company.valid"
								:validation-message="validator.fields.company.error"
							/>
							<InputComponent
								v-if="isFieldVisible('email')"
								v-model="data.email"
								:label="labels.email"
								required
								floating-label
								:is-valid="!submitted || validator.fields.email.valid"
								validation-message="Du må fylle ut e-postadresse"
							/>
							<InputComponent
								v-if="isFieldVisible('phone')"
								v-model="data.phone"
								:label="labels.phone"
								floating-label
								:is-valid="!submitted || validator.fields.phone.valid"
								:validation-message="validator.fields.phone.error"
							/>

							<!-- <InputComponent
									v-model="data.topic"
									:label="labels.topic"
									:is-valid="!submitted || validator.fields.topic.valid"
									:validation-message="validator.fields.topic.error"
									ref="topicInput"
									floating-label
									class="select-input"
								>
									<select class="elder-input__element" v-model="data.topic">
										<option disabled :value="null"></option>
										<option value="One">One</option>
										<option value="Two">Two</option>
										<option value="Three">Three</option>
									</select>
								</InputComponent> -->

							<InputComponent
								:label="labels.comment"
								required
								v-model="data.comment"
								ref="commentInput"
								:is-valid="!submitted || validator.fields.comment.valid"
								validation-message="Du må fylle ut hva henvendelsen gjelder. Maks 800 tegn."
								class="text-area"
								:class="{
									'elder-input--inactive': !textareaFucus && !Boolean(data.comment),
									'elder-input--focus': textareaFucus,
								}"
							>
								<textarea
									v-model="data.comment"
									class="elder-input__element"
									@focus="onCustomInputEvent('commentInput', 'onFocus')"
									@blur="onCustomInputEvent('commentInput', 'onBlur')"
									ref="contentTextArea"
								></textarea>
							</InputComponent>

							<InputComponent
								:value="data.files.join('-')"
								class="file-list"
								:is-valid="!submitted || validator.fields.fileSize.valid"
								validation-message="Samlet størrelse på alle vedlegg kan ikke overstige 5MB"
							>
								<FileList v-model="data.files" />
							</InputComponent>

							<div class="contact-form__button-wrapper ">
								<label class="file-upload mb-2">
									<input type="file" @change="onFileChange" multiple="multiple" ref="fileInput" />
									Legg til vedlegg
								</label>

								<ButtonComponent
									class="mt-2"
									theme="primary"
									label="Send forespørsel"
									success-label="Fullført"
									:state-timeout="4000"
									type="submit"
									:promise="promise"
								/>
							</div>
						</div>
					</template>
					<template #onError>
						<div class="contact-form__container-left contact-form--error">
							<TextField alignment="center">
								<h1 class="contact-form__title--error">Noe gikk galt..</h1>
							</TextField>
							<div class="contact-form__button-wrapper--error">
								<ButtonComponent theme="primary" label="Tilbake til forsiden" tag="router-link" to="/" />
							</div>
						</div>
					</template>
					<template #onSuccess>
						<div class="contact-form__container-left contact-form--success">
							<TextField alignment="center">
								<h2>Takk! Din henvendlese er mottatt.</h2>
								<span> Du hører fra oss innen kort tid.</span>
							</TextField>
							<div class="contact-form__button-wrapper--success">
								<ButtonComponent theme="primary" label="Tilbake til forsiden" tag="router-link" to="/" />
							</div>
						</div>
					</template>
				</FormLayout>
				<ContactInfo :category="category" class="contact-form__container-right" :cover="cover">
					<h4>Kontaktinformasjon</h4>
					<h6 class="mt-0">E-post</h6>

					<a class="a-none-deco mb-1" target="_blank" :href="`mailto:${info.email}`">{{ info.email }}</a>
					<h6 class="mt-2">Telefon</h6>
					<a class="a-none-deco" :href="`tel:${info.phone}`">{{ info.phone }}</a>
					<h6 class="mt-2">Adresse</h6>
					<a class="a-none-deco" target="_blank" :href="info.googleMaps">{{ info.address }}</a>
					<div class="mt-2 text-small">
						<a :href="info.googleMaps">Google maps </a>
					</div>
					<div class="mt-1">
						<small class="text-micro">
							Bankgiro: {{ info.bankgiro }}
							<br />
							Org.nr: {{ info.orgNr }} MVA
						</small>
					</div>
				</ContactInfo>
			</div>
		</div>
	</Loader>
</template>

<script>
import TextField from '@/components/TextField'
import FormLayout from '@/components/FormLayout'

import FileList from '@/components/FileList'
import RadioButton from '@/components/RadioButton.vue'
import ContactInfo from '@/components/ContactInfo.vue'
import Layout from '@/layouts/Default'

import Validator from '@/mixins/validator'
import { Clone } from '@/utils'
import Marked from 'marked'

const template = {
	email: null,
	company: null,
	name: null,
	phone: null,
	//topic: null,
	comment: null,
	files: [],
}

const PageData = [
	{
		path: 'bedrift',
		excludeFields: [],
	},
	{
		path: 'privat',
		excludeFields: ['!company'],
	},
]

export default {
	mixins: [Validator],
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},

	data() {
		return {
			textareaFucus: false,
			data: Clone(template),
			init: false,
			promise: null,
			submitted: false,

			validator: {
				rules: {
					name: 'required',
					company: 'max:40',
					email: 'required|email',
					phone: 'mobile',
					//topic: 'required',
					comment: 'required|max:800',
					fileSize: 'max:5000000',
				},
				labels: 'labels',
				data: 'dataComp',
				fucus: false,
			},
		}
	},
	computed: {
		cover() {
			let current = this.content.categories.find(element => element.title === this.category)
			return current.cover.url
		},
		title() {
			return Marked(this.content.title, true)
		},
		info() {
			return this.content.contactInformation
		},
		dataComp() {
			return {
				...this.data,
				type: this.category,
				fileSize: this.fileSize,
			}
		},
		category: {
			get() {
				return this.$route.query.contactCategory
			},
			set(val) {
				this.$router.replace({ query: { contactCategory: val } }).catch(() => {})
			},
		},
		currentData() {
			return PageData.find(p => p.path === this.category)
		},
		staticContent() {
			return StaticContentContact
		},
		fields() {
			return this.currentData.excludeFields
		},
		labels() {
			return {
				name: 'Navn',
				company: 'Bedrift(valgfritt)',
				email: 'E-post',
				phone: 'Mobilnummer(valgfritt)',
				//topic: 'Hva gjelder forespørselen?',
				comment: 'Hva kan vi hjelpe med?',
			}
		},
		fileSize() {
			return this.data.files.reduce((res, cur) => res + cur.size, 0)
		},
	},

	methods: {
		onFileChange(e) {
			this.data.files = Array.from(e.target.files || e.dataTransfer.files)
			this.$refs.fileInput.value = null
		},
		onCustomInputEvent(name, event) {
			switch (event) {
				case 'onFocus':
					this.textareaFucus = true
					break
				default:
					this.textareaFucus = false
			}
		},

		submit() {
			this.submitted = true

			if (!this.validator.passes) return

			let data = new FormData()
			Object.entries(this.dataComp).forEach(([key, value]) => {
				if (!value) return
				switch (key) {
					default:
						data.append(key, value)
						return
					case 'files':
						value.forEach(v => data.append('files', v))
						return
				}
			})

			return (this.promise = new Promise((resolve, reject) => {
				let request = new XMLHttpRequest()
				request.open('POST', '/api/contact')
				request.onload = function() {
					resolve(request.response)
				}
				request.onerror = function() {
					reject(request.response)
				}
				request.send(data)
			}).then(() => {
				this.reset()
			}))
		},
		reset() {
			this.data = Object.assign(Clone(template))
		},
		isFieldVisible(key) {
			let inclusions = this.fields.filter(f => !f.startsWith('!'))
			let exclusions = this.fields.filter(f => f.startsWith('!')).map(f => f.substring(1))
			if (inclusions.length) return inclusions.includes(key)
			if (exclusions.length) return !exclusions.includes(key)
			return true
		},
	},
	created() {
		this.$router.replace({ query: { contactCategory: 'privat' } }).catch(() => {})
	},

	components: {
		TextField,
		FormLayout,
		FileList,
		Layout,
		RadioButton,
		ContactInfo,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.contact-page {
	.form__content {
		height: 100%;
		border-radius: 4px 0 0 4px;
		@include respond-below('phone') {
			border-radius: 0px;
		}
	}

	.contact-form {
		$content-padding: 3rem 4.3rem 4rem 4.3rem;
		$padding-button: 1.5rem 2.5rem 1.5rem 2.5rem;
		&__container {
			display: grid;
			grid-template-columns: 543px 343px;
			justify-content: center;

			@include respond-below('phone') {
				display: grid;
				grid-template-columns: 1fr;
			}
			&-left {
				padding: $content-padding;
				@include respond-below('phone') {
					padding: 0.5rem 2.5rem 4rem 1.5rem;
				}
				&-button {
					top: -2rem;
				}
				&-title {
					margin-bottom: 2rem;
					@include respond-below('phone') {
						text-align: center;
						margin: 3rem 0;
					}
				}
			}
			&-right {
				border-radius: 0 4px 4px 0;
				background: $secondary;
				overflow: hidden;
				@include respond-below('phone') {
					border-radius: 0px;
				}
			}
		}
		&__button-wrapper {
			& > * + * {
				margin-left: 2rem;
			}
			@include respond-below('phone') {
				display: flex;
				flex-direction: column;
				& > * + * {
					margin: 0;
				}
			}
			&--success {
				padding: $padding-button;
			}
			&--error {
				@extend .contact-form__button-wrapper--success;
				color: $error;
			}
		}
		&__title {
			&--error {
				color: $error !important;
			}
		}
		&--success {
			@include respond-below('phone') {
				padding: 0rem;
			}
			text-align: center;
			padding: 6rem 6rem 1rem 6rem;
		}
		&--error {
			text-align: center;
			padding: 6rem 1rem 3rem 1rem;
		}
	}

	.file-list {
		margin-top: 0.5rem;

		.elder-input__field {
			border: none;
			max-height: initial !important;
		}
	}
}
</style>
